import { Injectable } from "@angular/core";
import { VasAppFacade } from "../../services/vas-app-facade.service";
import { Actions, Effect } from "@ngrx/effects";
import { Observable } from "rxjs/Observable";
import { Action } from "@ngrx/store";
import * as taskActions from "./task.actions";

@Injectable()
export class TaskSideEffectsService {

    @Effect({dispatch: false})
    setFilter$: Observable<Action> = this.actions$
        .ofType(taskActions.SET_FILTER)
        .do((action: taskActions.SetFilterAction) => {
            console.log("TaskSideEffect.setFilter");
            this.appFacade.objects.task.syncAll().take(1).subscribe();
        });

    @Effect({dispatch: false})
    loadNextPage$: Observable<Action> = this.actions$
        .ofType(taskActions.LOAD_NEXT_PAGE)
        .do((action: taskActions.LoadNextPage) => {
            console.log("TaskSideEffect.loadNextPage");
            this.appFacade.objects.task.syncAll().take(1).subscribe();
        });

    constructor(
        protected actions$: Actions,
        protected appFacade: VasAppFacade
    ) {

    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/task/task-side-effects.service.ts